import {useState, useRef, useMemo} from 'react';
import classnames from 'classnames';
import {registerPlugin} from '@wordpress/plugins';
import {getSetting} from '@woocommerce/settings';
import {ExperimentalOrderMeta} from '@woocommerce/blocks-checkout';
import {PaymentMethodMessagingElement, Elements} from "@stripe/react-stripe-js";
import {initStripe, isCartPage, isCheckoutPage} from "@wc-stripe/blocks-utils";

const data = getSetting('stripeBNPLCart_data');

const isSupported = (currency) => {
    const currencies = data.currencies;
    const countries = data.countries;
    if (currencies.length && !currencies.includes(currency.toUpperCase())) {
        return false;
    }
    return !(countries.length && !countries.includes(data.countryCode));

}

const MessageContent = ({cart, setAvailable, extensions, ...props}) => {
    const el = useRef(null)
    const {cartTotals} = cart;
    const options = useMemo(() => {
        const paymentMethods = extensions?.wc_stripe?.cart?.paymentMethods;
        const paymentMethodTypes = data.paymentMethods
            .filter(pm => !isCheckoutPage() || !!paymentMethods?.[pm.id]?.available)
            .map(pm => pm.paymentMethodType)
            .filter(Boolean);
        return {
            amount: parseInt(cartTotals.total_price),
            currency: cartTotals.currency_code,
            countryCode: data.countryCode,
            paymentMethodTypes
        };
    }, [cartTotals, extensions]);

    if (options.paymentMethodTypes.length <= 0 || !isSupported(options.currency)) {
        return null;
    }

    return (
        <div
            ref={el}
            className={classnames('wc-block-components-totals-item', {
                'wc-stripe-bnpl-cart-msg': isCartPage(),
                'wc-stripe-bnpl-checkout-msg': isCheckoutPage(),
            })}>
            <PaymentMethodMessagingElement
                options={options}
                onReady={(element) => {
                    setTimeout(() => {
                        const child = el.current?.querySelector('.StripeElement');
                        if (child && child.offsetHeight > 1) {
                            setAvailable(true);
                        } else {
                            setAvailable(false);
                        }
                    }, 250)
                }}
            />
        </div>
    );
}

const render = () => {
    const [available, setAvailable] = useState(null);
    if (isCheckoutPage() && data.locations.checkout === 'payment_method_title') {
        return null;
    }
    if (available === false) {
        return null;
    }
    return (
        <Elements
            stripe={initStripe}
            options={data.elementOptions}>
            <ExperimentalOrderMeta>
                <MessageContent setAvailable={setAvailable}/>
            </ExperimentalOrderMeta>
        </Elements>
    )
}

registerPlugin('wc-stripe-blocks-bnpl', {render, scope: 'woocommerce-checkout'});